<div class="add-family-member-container">
  <form [formGroup]="editFamilyMemberForm" (ngSubmit)="submit()">
    <div class="layout-row-wrap responsive-column align-start-center">
      <mat-form-field class="flex-50-minus-25px">
        <mat-label>{{ 'labels.inputs.First Name' | translate }}</mat-label>
        <input formControlName="firstName" required matInput />
        @if (editFamilyMemberForm.controls.firstName.hasError('required')) {
          <mat-error>
            {{ 'labels.inputs.First Name' | translate }} {{ 'labels.commons.is' | translate }}
            <strong>{{ 'labels.commons.required' | translate }}</strong>
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field class="flex-50-minus-25px">
        <mat-label>{{ 'labels.inputs.Middle Name' | translate }}</mat-label>
        <input formControlName="middleName" matInput />
      </mat-form-field>

      <mat-form-field class="flex-50-minus-25px">
        <mat-label>{{ 'labels.inputs.Last Name' | translate }}</mat-label>
        <input formControlName="lastName" required matInput />
        @if (editFamilyMemberForm.controls.lastName.hasError('required')) {
          <mat-error>
            {{ 'labels.inputs.Last Name' | translate }} {{ 'labels.commons.is' | translate }}
            <strong>{{ 'labels.commons.required' | translate }}</strong>
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field class="flex-50-minus-25px">
        <mat-label>{{ 'labels.inputs.Qualification' | translate }}</mat-label>
        <input formControlName="qualification" matInput />
      </mat-form-field>

      <mat-form-field class="flex-50-minus-25px">
        <mat-label>{{ 'labels.inputs.Age' | translate }}</mat-label>
        <input type="number" formControlName="age" matInput disabled />
      </mat-form-field>

      <mat-checkbox formControlName="isDependent" labelPosition="before" class="flex-50-minus-25px">
        {{ 'labels.inputs.Is Dependent' | translate }}
      </mat-checkbox>

      <mat-form-field class="flex-50-minus-25px">
        <mat-label>{{ 'labels.inputs.Relationship' | translate }}</mat-label>
        <mat-select formControlName="relationshipId" required>
          @for (relation of addFamilyMemberTemplate.relationshipIdOptions; track relation) {
            <mat-option [value]="relation.id">
              {{ relation.name | translateKey: 'catalogs' }}
            </mat-option>
          }
        </mat-select>
        @if (editFamilyMemberForm.controls.relationshipId.hasError('required')) {
          <mat-error>
            {{ 'labels.inputs.Relationship' | translate }} {{ 'labels.commons.is' | translate }}
            <strong>{{ 'labels.commons.required' | translate }}</strong>
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field class="flex-50-minus-25px">
        <mat-label>{{ 'labels.inputs.Gender' | translate }}</mat-label>
        <mat-select formControlName="genderId" required>
          @for (gender of addFamilyMemberTemplate.genderIdOptions; track gender) {
            <mat-option [value]="gender.id">
              {{ gender.name | translateKey: 'catalogs' }}
            </mat-option>
          }
        </mat-select>
        @if (editFamilyMemberForm.controls.genderId.hasError('required')) {
          <mat-error>
            {{ 'labels.inputs.Gender' | translate }} {{ 'labels.commons.is' | translate }}
            <strong>{{ 'labels.commons.required' | translate }}</strong>
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field class="flex-50-minus-25px">
        <mat-label>{{ 'labels.inputs.Profession' | translate }}</mat-label>
        <mat-select formControlName="professionId">
          @for (profession of addFamilyMemberTemplate.professionIdOptions; track profession) {
            <mat-option [value]="profession.id">
              {{ profession.name | translateKey: 'catalogs' }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field class="flex-50-minus-25px">
        <mat-label>{{ 'labels.inputs.Marital Status' | translate }}</mat-label>
        <mat-select formControlName="maritalStatusId">
          @for (maritalStatus of addFamilyMemberTemplate.maritalStatusIdOptions; track maritalStatus) {
            <mat-option [value]="maritalStatus.id">
              {{ maritalStatus.name | translateKey: 'catalogs' }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field class="flex-fill" (click)="dueDatePicker.open()">
        <mat-label>{{ 'labels.inputs.Date Of Birth' | translate }}</mat-label>
        <input
          formControlName="dateOfBirth"
          matInput
          [max]="maxDate"
          [matDatepicker]="dueDatePicker"
          placeholder="Optional"
        />
        <mat-datepicker-toggle matSuffix [for]="dueDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #dueDatePicker></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="layout-row gap-32px layout-align-center">
      <button type="button" mat-raised-button [routerLink]="['../../']">
        {{ 'labels.buttons.Cancel' | translate }}
      </button>
      <button
        type="submit"
        mat-raised-button
        color="primary"
        [disabled]="editFamilyMemberForm.pristine || !editFamilyMemberForm.valid"
      >
        {{ 'labels.buttons.Submit' | translate }}
      </button>
    </div>
  </form>
</div>
